import styled from 'styled-components';

export const StyledH2 = styled.h2`
  font-size: 18px;
  font-weight: normal;
`;

export const StyledH1 = styled.h1`
  margin-bottom: 60px;
`;
